<template>
<div class="slider__buttons">
  <button class="slider__button slider__button-prev" @click="$emit('prev')" :disabled="disabled">
    <img alt="slider-button" src="/svg/products/arrow-right.svg">
  </button>

  <button class="slider__button slider__button-next" @click="$emit('next')" :disabled="disabled">
    <img alt="slider-button" src="/svg/products/arrow-left.svg">
  </button>
</div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['prev', 'next'],
  components: {},
  data() {
    return {

    };
  },
};
</script>

<style lang="scss" scoped>
$white: #FFFFFF;
$dark-gray: #2B3138;
$light-gray: #D5D6D7;
$purple: #8293E8;
$yellow: #F8A81B;
$green: #27AE60;
$blue:#4DB6BC;

.slider {

  &__buttons {
    display: flex;
    align-items: center;
    position: absolute;
    width: 100%;
    top: 50%;

    .class-ways__slider & {
      display: none;
    }

    @media (max-width: 825px) {
      .class-ways__slider.coral & {
        display: flex;
      }
    }

    @media (max-width: 635px) {
      .class-ways__slider.blue & {
        display: flex;
      }
    }

    @media (max-width: 542px) {
      padding: 30px 0;
      justify-content: space-between;
      width: 100%;
    }

    @media (max-width: 480px) {
      justify-content: center;
      width: 85%;
      flex-wrap: wrap;
      padding: 15px 0 0;
    }
  }

  &__button {
    position: absolute;
    border: none;
    font-family: 'montserratbold', sans-serif;
    font-size: 14px;
    line-height: 22px;
    background: transparent;
    cursor: pointer;

    &-prev,
    &-next {
      display: block;
      padding: 11px 25px;

      @media (max-width: 542px) {
        padding: 10px 25px;
      }

      @media (max-width: 480px) {
        padding: 0;
      }
    }

    &-prev {
      left: 0;
      @media (max-width: 825px) {
        .class-ways__slider & {
          left: -45px;
        }
      }
    }

    &-next {
      right: 0;
      @media (max-width: 825px) {
        .class-ways__slider & {
          right: -45px;
        }
      }
    }
  }

}

.list-move,
.list-enter-active,
.list-leave-active {
  transition: all .3s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.list-leave-active {
  position: absolute;
}
</style>
